/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.MeevoMessengerSettings {
    'use strict';

    import IMeevoMessengerAutoReply = Meevo.Model.IMeevoMessengerAutoReply;
    import IMeevoMessengerSettings = Meevo.Model.IMeevoMessengerSettings;
    import MeevoMessengerAutoRepliesEnum = Meevo.Model.MeevoMessengerAutoRepliesEnum;
    import MeevoMessengerMessages = Meevo.Plugins.MeevoMessenger.MeevoMessengerMessages;

    class TwoWaySmsSettingsController {
        static $inject = [
            'meevo.AppSettings',
            'meevo.components.common.BusinessInfoDataService',
            'meevo.components.modal.ModalService',
            'meevo.components.common.IdentityService',
            'meevo.components.logging.LoggingService',
            'meevo.components.common.SecurityService',
            'meevo.components.tracking.TrackingService',
            'meevo.components.busy.BusyService',
            'meevo.plugins.meevoMessengerSettings.meevoMessengerSettingsService',
            '$rootScope',
            '$scope',
            '$state',
            'meevo.ContextParams',
            'meevo.components.short-cuts.ShortCutsService',
            '$filter',
            '$q',
            '$translate'
        ];

        public params: ISectionParamsMeevoMessengerSettings;
        public model: Partial<any>;
        public employeesCriteria = {
            showEmployeesOnly: true,
            includeActive: true,
            includeInactive: true,
            iIncludeDeleted: true
        };

        public isEditingMessaging: boolean = false;
        public countryCode: string = '1';
        public autoReplies: IMeevoMessengerAutoReply[] = [
            { type: MeevoMessengerAutoRepliesEnum.DefaultAutoReplyMessage, name: 'LABEL_AWAY_FROM_DESK', editingLabel: 'LABEL_MEEVO_MESSENGER_DEFAULT_AUTO_REPLY_MESSAGE', default: 'TEXT_MEEVO_MESSENGER_DEFAULT_AUTOREPLY_MESSAGE' },
            { type: MeevoMessengerAutoRepliesEnum.HolidayAutoReplyMessage, name: 'LABEL_CLOSED_FOR_HOLIDAY', editingLabel: 'LABEL_MEEVO_MESSENGER_HOLIDAY_AUTO_REPLY_MESSAGE', default: 'TEXT_MEEVO_MESSENGER_CLOSED_FOR_HOLIDAY_MESSAGE' },
            { type: MeevoMessengerAutoRepliesEnum.OutsideHoursAutoReplyMessage, name: 'LABEL_MEEVO_MESSENGER_OUTSIDE_HOURS', editingLabel: 'LABEL_MEEVO_MESSENGER_OUTSIDE_HOURS_AUTO_REPLY_MESSAGE', default: 'TEXT_MEEVO_MESSENGER_AFTER_HOURS_MESSAGE' }
        ];
        private classification: string = 'sms';
        private disableCrud: boolean;

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
                    protected dataService: Meevo.Components.CommonClasses.ICommonDataService,
                    protected modalService: Meevo.Components.Modal.IModalService,
                    protected identityService: Meevo.Components.Common.IIdentityService,
                    protected loggingService: Meevo.Components.Logging.ILoggingService,
                    protected securityService: Meevo.Components.Common.ISecurityService,
                    protected trackingService: Meevo.Components.Tracking.ITrackingService,
                    protected busyService: Meevo.Components.Busy.IBusyService,
                    protected meevoMessengerSettingsService: IMeevoMessengerSettingsService,
                    protected $rootScope: angular.IRootScopeService,
                    protected $scope: angular.IScope,
                    protected $state: any,
                    protected contextParams: any,
                    protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
                    protected $filter: angular.IFilterService,
                    protected $q: angular.IQService,
                    private $translate: angular.translate.ITranslateService
        ) {
            this.disableCrud = false


            this.$scope.$on('EDIT_MODE_SETTINGS', () => {
                this.startEditingMessaging();
            });

            this.$scope.$on('SAVE_MODE_SETTINGS', () => {
                this.endEditingMessaging();
            });

            this.$scope.$on('CANCEL_MODE_SETTINGS', () => {
                this.endEditingMessaging();
            });

            this.$scope.$on('PRE_SAVE_MODE_SETTINGS', () => {
                this.preSave();
            });
        }


        $onInit() {
            this.model.quickAnswers = this.$filter('orderBy')(this.model.quickAnswers, 'orderNumber');
            this.autoPopulateQuickReply();

            this.autoReplies = this.autoReplies.map((autoReply: IMeevoMessengerAutoReply) => {
                Object.defineProperty(autoReply, 'body', {
                    get: () => { return this.model[this.autoReplyPropertyName(autoReply.type)]; },
                    set: (newValue: string) => { this.model[this.autoReplyPropertyName(autoReply.type)] = newValue; }
                });
                return autoReply;
            });
        }

        initialSetup() {
            this.params.busyService.start();
            console.log('Initial Setup!!!');
            this.params.busyService.stop();
        }

        // deletePhoneNumber(callback: Function) {
        //     this.modalService.confirm('LABEL_DELETE_ACCOUNT_CONFIRMATION')
        //         .then(res => this.deleteAccountRequest())
        //         .then(() => {
        //             this.model = this.defaultModel;
        //             this.autoPopulateQuickReply();
        //             this.takeBackup();
        //             this.clearTextelSettingsAndAuth();
        //             setTimeout(() => { this.model.userName = "" }, 0)
        //             callback();
        //         })
        //         .catch(err => {})
        // }

        preSave(): void {
            this.isBusinessHour();
            this.autoPopulateQuickReply();
            this.endEditingMessaging();
            // Categories ids from the smart mover
            delete this.model.userCategoriesIdsList;
        }

        isBusinessHour() {
            if (this.model.useBusinessHours) {
                this.model.isAutoReplyEnabled = false;
            }
        }

        loginAuthorization(userName: string, token: string): ng.IPromise<any> {
            return this.meevoMessengerSettingsService.meevoMessengerLogin({ userName, token, classification: 'Textel'});
        }

        deleteQuickResponse(index: number): void {
            this.model.quickAnswers.splice(index, 1);
        }

        edit() {
            this.startEditingMessaging();
            console.log('fire edit in component');
        }
        //
        // rollbackChanges() {
        //     // super.rollbackChanges();
        //     this.endEditingMessaging();
        // }

        private clearTextelSettingsAndAuth(): void {
            this.$rootScope.$broadcast(MeevoMessengerMessages.CLEAR_TEXTEL_SETTINGS_AND_AUTH)
        }

        private deleteAccountRequest(): any {
            this.params.busyService.start();
            this.meevoMessengerSettingsService.deleteAccount()
                .then(() => this.$q.resolve({}))
                .finally(() => {this.params.busyService.stop()})
        }

        private autoPopulateQuickReply(): void {
            this.autoReplies.forEach(autoReply => {
                let propertyName = this.autoReplyPropertyName(autoReply.type);
                if (!this.model[propertyName]) {
                    this.model[propertyName] = this.$translate.instant(autoReply.default);
                }
            });
        }

        private autoReplyPropertyName(type: MeevoMessengerAutoRepliesEnum): string {
            let propertyName = MeevoMessengerAutoRepliesEnum[type];
            // Set first letter to lower case
            return propertyName.charAt(0).toLowerCase() + propertyName.substr(1);
        }

        private startEditingMessaging(): void {
            this.isEditingMessaging = true;
        }

        private endEditingMessaging(): void {
            this.isEditingMessaging = false;
        }

        private isShowSuccessfullLogin(meevoMessengerLoginAuth: any): boolean {
            return !meevoMessengerLoginAuth.$error.credentialsVerifyError && meevoMessengerLoginAuth.$submitted && !meevoMessengerLoginAuth.$pending;
        }

        private isShowAuthorizationFailed(meevoMessengerLoginAuth: any): boolean {
            return meevoMessengerLoginAuth.$error.credentialsVerifyError && meevoMessengerLoginAuth.$submitted && !meevoMessengerLoginAuth.$pending;
        }

        private isValidMeevoMessengerAuthFields(meevoMessengerLoginAuth: any): boolean {
            return meevoMessengerLoginAuth.meevoMessengerUserName.$valid && meevoMessengerLoginAuth.meevoMessengerToken.$valid;
        }

        get defaultModel() {
            return {
                isAutoReplyEnabled: false,
                autoReplyKind: 0,
                defaultAutoReplyMessage:"",
                entityVersion: 0,
                holidayAutoReplyMessage: "",
                isAccountInitialized: false,
                locationId: 0,
                outsideHoursAutoReplyMessage: "",
                quickAnswers: [],
                tenantId: 0,
                useBusinessHours: false,
                userCategoriesIdsList: [],
                userName: "",
                token: "",
                usersToNotify: []
            }
        }

        get securityAccessEnum() {
            return Meevo.Model.SecurityAccessEnum;
        }

        get messageLengthLimit(): number {
            return Meevo.Plugins.MeevoMessenger.Constants.MESSAGE_SMS_LENGTH_LIMIT
        }
    }

    class TwoWaySmsSettingsComponent implements angular.IComponentOptions {
        templateUrl = 'app/plugins/meevoMessengerSettings/components/twsSettings/twoWaySms.settings.html';
        controller = TwoWaySmsSettingsController;
        controllerAs = 'tws';
        bindings: any = {
            isReadonly: '=',
            disableCrud: '=',
            model: '='
        };
    }

    angular.module('meevo.plugins.meevoMessengerSettings')
        .component('twsSettings', new TwoWaySmsSettingsComponent());

}

